<template>
  <PackTasks team="packing" :show-clear-tasks="isAdmin"/>
</template>

<script>


import PackTasks from "@/components/tasks/PackTasks.vue";

export default {
  name: "PackingTasks",
  components: {PackTasks},
  props: {
    isAdmin: {type: Boolean, default: false, required: false}
  },
}
</script>

<style scoped>

</style>
